
const styles = theme => ({
    grow: {
        flexGrow: 1
    },

    toolbar: {
        borderBottom: `1px solid rgba(0, 0, 0, 0.12)`
    },

    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        flexWrap: "wrap",
        gap: "10px", 
    },
    leftSection: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        flexWrap: "nowrap", 
    },
    rightSection: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        flexWrap: "wrap", 
        justifyContent: "flex-end",
        minWidth: "120px", 
    },

    tableContainer: {
        margin: "20px",
        maxHeight: 'calc(100vh - 250px)',
        maxWidth: '1270px',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        [theme.breakpoints.up('xs')]: {
          maxWidth: '400px',
        },
        [theme.breakpoints.up('sm')]: {
          maxWidth: '600px', 
        },
        [theme.breakpoints.up('md')]: {
         maxWidth: '1000px', 
        },
        [theme.breakpoints.up('lg')]: {
          maxWidth: '1270px',
        },
    },
    headerCell: {
        fontWeight: "bold",
        textAlign: "center",
        background: "#f5f5f5",
        position: 'sticky',
        left: 0,
        zIndex: 2,
        minWidth: '80px',
    },
    slotCell:{
        fontWeight: "bold",
        textAlign: "center",
        background: "#f5f5f5",
        position: 'sticky',
        left: 0,
        zIndex: 2,
        minWidth: '50px',
        padding: "0 !important",
    },
    timeCell: {
        fontWeight: "bold",
        textAlign: "center",
        background: "#eeeeee",
        position: 'sticky',
        left: 0,
        zIndex: 1,
        minWidth: "50px",
        maxWidth: "60px",
        height: "40px",
        lineHeight: 1,

    },
    bookingCell: {
        minWidth: "50px",
        maxWidth: "50px", 
        border: "1px solid #ddd",
        height: "50px",
        padding: "0 !important", 
        borderLeft: "8px solid transparent",
    },
    
    confirmed: {
        background: "#daecdbff",
        color: "#28a745",
        border: "1px solid #388e3c",
        width: "30px",
        height: "30px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
    },
    canceled: {
        background: "#ffecb3",
        border: "1px solid #ff9800"
    },
    emptySlot: {
        background: "#eeeeee",
        border: "1px dashed #bdbdbd",
        cursor: "pointer",   
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: '6px',
        width: "30px",
        height: "30px",
    },
   
    modalContent: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "30px",
        borderRadius: "10px",
        boxShadow: 24,
        width: '90%',
        maxWidth: 500,
        border: "none !important",
        outline: "none !important",
    },
    "@media (max-width: 480px)": {
      container: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px",
      },
      rightSection: {
        justifyContent: "flex-start",
        minWidth: "100%",
      },
  },
})

export default styles

